// import { ContentCard } from "sj-ui-toolkit/src/atlas/components";
import { ContentCard } from "../../ContentCard/ContentCard";
import { ContentCardProps } from "../../ContentCard/contentCardTypes";

interface LessonsContainerProps {
  title: string;
  lessons?: ContentCardProps[];
}

export const LessonsContainer = ({ title, lessons = [] }: LessonsContainerProps) => {
  return (
    <div className="py-8">
      <h2 className="atlas-h5">{title}</h2>
      <div className="flex flex-wrap gap-6 mt-4">
        {lessons.map(lesson => (
          <ContentCard key={lesson.id} {...lesson} />
        ))}
      </div>
    </div>
  );
};
